import { render, staticRenderFns } from "./Popularidad.vue?vue&type=template&id=f0df5f3a"
import script from "./Popularidad.vue?vue&type=script&lang=js"
export * from "./Popularidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports